<template>
  <div class="contact">
    <Banner fromType="contact" />
    <section class="contact-content">
      <div class="container">
        <div class="contact-grid">
          <div>
            <img :src="constactData.addressImgUrl" alt="联系我们" class="contact-map">
          </div>
          <div>
            <div class="title">
              <h3>联系我们</h3>
              <p class="small-text">Contact Us</p>
            </div>
            <p v-if="constactData.name" class="contact-info-item">
              <img src="@/assets/images/contact/contact_icon_01.png" alt="公司地址">
              <span>{{constactData.name}}</span>
            </p>
            <p v-if="constactData.stockCode" class="contact-info-item">
              <img src="@/assets/images/contact/contact_icon_02.png" alt="公司地址">
              <span>证券代码：{{constactData.stockCode}}</span>
            </p>
            <p v-if="constactData.mobile" class="contact-info-item">
              <img src="@/assets/images/contact/contact_icon_03.png" alt="公司地址">
              <span>电话：{{constactData.mobile}}</span>
            </p>
            <p v-if="constactData.email" class="contact-info-item">
              <img src="@/assets/images/contact/contact_icon_04.png" alt="公司地址">
              <span>邮箱：{{constactData.email}}</span>
            </p>
            <p v-if="constactData.address" class="contact-info-item">
              <img src="@/assets/images/contact/contact_icon_05.png" alt="公司地址">
              <span>地址：{{constactData.address}}</span>
            </p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { usePageSeo } from '~/composables/useSeo'
import { useHttpApi } from '~/composables/useApi'
import Banner from './compontents/banner.vue'
// 使用useHead替代usePageSeo避免middleware中的警告
usePageSeo({
  title: '联系我们-苏州瀚易特信息技术股份有限公司',
  description: '联系我们获取瀚林愿AI成长平台详细方案！提供商务合作、技术支持与产品试用咨询，期待与您共建智慧教育未来。',
  keywords: '瀚易特、瀚林愿、教育信息化合作咨询',
  url: 'contact'
})

interface ContactData {
  name: string,
  stockCode: string,
  mobile: string,
  email: string,
  address: string,
  addressImgUrl: string
}

const constactData = ref({} as ContactData)

const { getCompanyContactApi } = useHttpApi()
const getContactList = async () => {
  const res = await getCompanyContactApi()
  constactData.value = res?.data?.data
}
onMounted(() => {
  getContactList()
})
</script>

<style scoped lang="scss">
@use "sass:color";
@use "~~/assets/scss/main.scss" as *;

.contact-content {
  padding: 3rem 0;
}

.contact-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4rem;
}

.contact-title {
  width: 304px;
  height: 85px;
  margin: 40px 0;
}

.contact-info-item {
  display: flex;
  align-items: center;
  gap: 5px;
  margin-bottom: 10px;
  font-weight: 400;
  font-size: 16px;
  color: rgba(0,0,0,0.7);
  img {
    width: 30px;
    height: 30px;
  }
  
  &:last-child {
    margin-bottom: 0;
  }
}
.title {
  margin: 100px 0 20px;
  .small-text {
    font-size: 12px;
    color: rgba($color: #000000, $alpha: 0.3);
    text-transform: uppercase;
  }
}
.contact-map {
  width: 674px;
  height: 512px;
}

@media (max-width: 768px) {
  .contact-grid {
    grid-template-columns: 1fr;
    gap: 2rem;
  }
}
</style>